// extracted by mini-css-extract-plugin
export default {"link":"o_N2n7","withPrefix":"CTT4JR"};